var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g(_vm._b({staticClass:"cancel-button",attrs:{"type":"reset"}},'Button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.translateIfKey(_vm.label)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }